import MaterialIcon from '@material/react-material-icon';
import { DeactivateAppData } from '../../../../../_api';
import { Button } from '@upmc/ims.component-library';
import AppDataUpdateRequest from '../../../../../../../Classes/ResponseModels/ApplicationManagement/AppDataUpdateRequest';
import styles from '../../../../../ApplicationMaintenance.module.scss';
const AppDataDeactivationButton = ({
	appData,
	app,
	currentUser,
	component,
	reload,
	requirementNumber,
	readOnly,
}) => {
	const handleClick = e => {
		const request = new AppDataUpdateRequest(app, currentUser, appData);
		request.RequirementNumber = requirementNumber;

		DeactivateAppData(request).then(response => reload());
	};

	return (
		<div className={styles.controlsContainer}>
			<Button
				id={appData.id}
				startIcon={<MaterialIcon icon='delete' />}
				onClick={handleClick}
				disabled={readOnly}
			>
				Delete
			</Button>
		</div>
	);
};

export default AppDataDeactivationButton;
